import { motion } from "framer-motion";
import { Check, X, Zap } from "lucide-react";

const comparisons = [
  { feature: "Focado no freelancer solo", others: false, freeladash: true },
  { feature: "Valor hora real automático", others: false, freeladash: true },
  { feature: "Projeção de receita mensal", others: false, freeladash: true },
  { feature: "Simulador CLT vs PJ", others: false, freeladash: true },
  { feature: "Interface simples e objetiva", others: false, freeladash: true },
  { feature: "Dashboard financeiro integrado", others: false, freeladash: true },
  { feature: "Alertas de concentração de clientes", others: false, freeladash: true },
  { feature: "Margem de lucro por projeto", others: false, freeladash: true },
];

export function ComparisonSection() {
  return (
    <section className="relative py-20 sm:py-28 bg-gradient-to-b from-muted/30 to-background overflow-hidden">
      <div className="container relative mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-medium mb-6">
            <Zap className="h-4 w-4" />
            Comparativo
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-wide text-foreground mb-4">
            ENQUANTO OUTRAS FERRAMENTAS{" "}
            <span className="text-muted-foreground">COMPLICAM...</span>
          </h2>
          <p className="text-2xl sm:text-3xl font-bold text-primary">
            O FREELADASH SIMPLIFICA.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-4xl mx-auto"
        >
          <div className="rounded-2xl border border-border overflow-hidden bg-card shadow-lg">
            {/* Header */}
            <div className="grid grid-cols-3 bg-muted border-b border-border">
              <div className="p-4 sm:p-6">
                <span className="text-muted-foreground font-medium text-sm sm:text-base">Funcionalidade</span>
              </div>
              <div className="p-4 sm:p-6 text-center border-l border-border">
                <span className="text-muted-foreground font-medium text-sm sm:text-base">Outras ferramentas</span>
              </div>
              <div className="p-4 sm:p-6 text-center border-l border-border bg-primary/5">
                <span className="text-primary font-bold text-sm sm:text-base">FreelaDash</span>
              </div>
            </div>

            {/* Rows */}
            {comparisons.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: index * 0.05 }}
                className={`grid grid-cols-3 ${
                  index % 2 === 0 ? "bg-background" : "bg-muted/30"
                } ${index !== comparisons.length - 1 ? "border-b border-border" : ""}`}
              >
                <div className="p-4 sm:p-5 flex items-center">
                  <span className="text-foreground text-sm sm:text-base">{item.feature}</span>
                </div>
                <div className="p-4 sm:p-5 flex items-center justify-center border-l border-border">
                  {item.others ? (
                    <div className="w-8 h-8 rounded-full bg-success/10 flex items-center justify-center">
                      <Check className="h-5 w-5 text-success" />
                    </div>
                  ) : (
                    <div className="w-8 h-8 rounded-full bg-destructive/10 flex items-center justify-center">
                      <X className="h-5 w-5 text-destructive" />
                    </div>
                  )}
                </div>
                <div className="p-4 sm:p-5 flex items-center justify-center border-l border-border bg-primary/5">
                  {item.freeladash ? (
                    <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
                      <Check className="h-5 w-5 text-primary" />
                    </div>
                  ) : (
                    <div className="w-8 h-8 rounded-full bg-destructive/10 flex items-center justify-center">
                      <X className="h-5 w-5 text-destructive" />
                    </div>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
